import React, { useMemo } from 'react';
import { SecurityContextTemplate, PermissionsMap, useGlobalSecurityReactContext } from 'framework/authorization';
import { useNewProjectService } from 'domain/shared/newProject';
import { useParams } from 'react-router-dom';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';

export const NEW_PROJECT_CONTEXT = 'newProject';

const NewProjectContext = ({
  permissionToCheck,
  subEntityType,
  getSubEntityId,
  children,
}: {
  permissionToCheck: string | string[];
  subEntityType?: string;
  getSubEntityId?: (params: Dictionary<string | undefined>) => string | undefined;
  children: React.ReactNode;
}) => {
  const params = useParams<Dictionary<string>>();
  const subEntityId = useMemo(() => getSubEntityId?.(params), [getSubEntityId, params]);
  const { addMessage } = useMessageService();

  const { getProjectEntityPermissions } = useNewProjectService();
  const globalContext = useGlobalSecurityReactContext() || {};

  return (
    <SecurityContextTemplate
      id={params.id!}
      getPermissionsFunc={id =>
        Promise.all([
          Promise.resolve(Object.keys(globalContext.permissions as unknown as PermissionsMap) || []),
          getProjectEntityPermissions('Project', id),
          subEntityType && subEntityId ? getProjectEntityPermissions(subEntityType, subEntityId) : Promise.resolve([]),
        ])
          .then(permissions => {
            return permissions.reduce((flatten, arr) => [...flatten, ...arr]);
          })
          .catch(e => {
            addMessage(new ErrorMessage(`Project context error: ${e}`));
            return [];
          })
      }
      permissionToCheck={permissionToCheck}
      contextName={NEW_PROJECT_CONTEXT}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default NewProjectContext;
